module.exports = __webpack_public_path__ + "media/fallback/josh-w-bc5fd61c.jpg";